import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

function PrivateRoute({ children }) {
  const { userIsAuthenticated } = useAuth()
  if (!userIsAuthenticated()) {
    return <Navigate to="/login" />
  }
  return children || <Outlet />
}

export default PrivateRoute
